import { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
let globalConnecting = false;
let globalSession = null;

export default function VoiceModal({ isOpen, incomingJsep, setIncomingJsep, onClose }) {
    const [number, setNumber] = useState("");
    const [status, setStatus] = useState("Offline");
    const [hint, setHint] = useState("");
    const [incomingCall, setIncomingCall] = useState(false);
    const gatewayRef = useRef(null);
    const sessionRef = useRef(null);
    const incomingJsepRef = useRef(incomingJsep);
    const { user } = useContext(AuthContext);
    const localMicStreamRef = useRef(null);
    const remoteStreamRef = useRef(null);
    const [sipReady, setSipReady] = useState(false);

    const waitingForCalleeRef = useRef(false);
    const audioRef = useRef(null);

    const modalRef = useRef(null);

    const [position, setPosition] = useState({
        x: window.innerWidth / 2 - 180,
        y: window.innerHeight / 2 - 360,
    });
    const [dragging, setDragging] = useState(false);
    const offsetRef = useRef({ x: 0, y: 0 });

    const PLAY_LOCAL_RINGBACK = true;

    const server = "wss://sip.notificame.com.br/rtc/ws";
    const localRingCtxRef = useRef(null);
    const localRingIntervalRef = useRef(null);

    const add = (n) => setNumber((prev) => prev + n);
    const clearNumber = () => setNumber("");


    const startLocalRingback = () => {
        if (!PLAY_LOCAL_RINGBACK) return;

        stopLocalRingback();

        try {
            const AudioCtx = window.AudioContext || window.webkitAudioContext;
            const ctx = new AudioCtx();

            localRingCtxRef.current = ctx;

            const playBurst = () => {
                if (!ctx || ctx.state === "closed") return;

                const gain = ctx.createGain();
                gain.gain.value = 0.06;

                const o1 = ctx.createOscillator();
                const o2 = ctx.createOscillator();

                o1.frequency.value = 440;
                o2.frequency.value = 480;

                o1.connect(gain);
                o2.connect(gain);
                gain.connect(ctx.destination);

                o1.start();
                o2.start();

                const stopAt = ctx.currentTime + 2;
                o1.stop(stopAt);
                o2.stop(stopAt);
            };

            const kick = () => {
                playBurst();

                localRingIntervalRef.current = setInterval(() => {
                    playBurst();
                }, 6000);
            };

            if (ctx.state === "suspended") {
                ctx.resume().then(kick).catch(kick);
            } else {
                kick();
            }

        } catch (e) {
            stopLocalRingback();
        }
    };

    const stopLocalRingback = () => {
        if (localRingIntervalRef.current) {
            clearInterval(localRingIntervalRef.current);
            localRingIntervalRef.current = null;
        }

        if (localRingCtxRef.current) {
            try {
                localRingCtxRef.current.close();
            } catch (e) { }
            localRingCtxRef.current = null;
        }
    };


    const attachRemoteTrack = (track) => {
        if (!track || track.kind !== "audio") return;

        if (!remoteStreamRef.current) {
            remoteStreamRef.current = new MediaStream();
        }

        // limpa tracks antigas
        remoteStreamRef.current.getTracks().forEach((t) => {
            remoteStreamRef.current.removeTrack(t);
        });

        remoteStreamRef.current.addTrack(track);

        if (audioRef.current) {
            const el = audioRef.current;

            el.srcObject = remoteStreamRef.current;
            el.volume = 1;

            // 🚀 NÃO muta antes
            el.muted = false;

            el.play()
                .then(() => {
                    console.log("🔊 áudio tocando");
                })
                .catch((err) => {
                    console.log("❌ erro ao tocar", err);
                });
        }
    };



    function ensureMicrophonePermission() {
        if (!window.isSecureContext) {
            setStatus("Use HTTPS ou http://localhost — file:// não permite microfone.");
            return Promise.reject(new Error("insecure context"));
        }

        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            setStatus("Navegador sem suporte a getUserMedia.");
            return Promise.reject(new Error("no getUserMedia"));
        }
        setStatus("Permitindo microfone...");
        return navigator.mediaDevices
            .getUserMedia({ audio: true })
            .then((stream) => {
                stream.getTracks().forEach((t) => t.stop());
            }).catch((err) => {
                const msg = err.name === "NotAllowedError" ? "Microfone negado pelo usuário." : (err.message || String(err));
                setStatus(msg);
                throw err;
            });
    }



    const register = (userData) => {

        if (!userData?.usernameSIP || !userData?.secretSIP) {
            return;
        }
        if (!sessionRef.current) {
            console.log(" sessionRef.current não existe");
            return;
        }

        
        try {

            sessionRef.current.send({
                message: {
                    request: "register",
                    username: `sip:${userData.usernameSIP}@sip.notificame.com.br`,
                    secret: userData.secretSIP,
                }
            });

        } catch (e) {
            console.error("erro ao enviar register:", e);
        }
    };
    const connectingRef = useRef(false);
    function connect() {
        setStatus("Conectando...");
        if (globalSession || globalConnecting) {
            console.log("🌍 Já conectado globalmente");
            return;
        }
        globalConnecting = true;
        connectingRef.current = true;
        setStatus("Conectando...");
        ensureMicrophonePermission()
            .then(() => {
                window.NotificaMeRTC.init({
                    debug: false,
                    callback: () => {

                        gatewayRef.current = new window.NotificaMeRTC({
                            server: server,

                            success: () => {
                                setStatus("Conectado");
                                gatewayRef.current.attach({
                                    plugin: "NotificaMeSip",

                                    success: (handle) => {
                                        globalSession = handle;
                                         globalConnecting = false;
                                        sessionRef.current = handle;
                                        setStatus("SIP pronto");
                                        setSipReady(true);
                                    },

                                    onremotetrack: (track, mid, on) => {
                                        if (!on) return;
                                        attachRemoteTrack(track);
                                    },

                                    onmessage: (msg, jsep) => {

                                        if (msg.error) {
                                            setStatus("SIP: " + (typeof msg.error === "string"
                                                ? msg.error
                                                : JSON.stringify(msg.error)));
                                            return;
                                        }

                                        const ev = msg.result?.event;
                                        console.log("eve",ev)
                                        if (ev === "registered") {
                                            setStatus("Registrado");
                                            setHint("");
                                        }

                                        if (ev === "calling") {
                                            setStatus("Chamando…");
                                            setHint("Aguardando resposta do destino...");
                                            startLocalRingback();

                                        }

                                        if (ev === "progress" || ev === "ringing") {
                                            setStatus("Destino tocando…");
                                        }

                                        if (ev === "accepted" || ev === "updatingcall") {
                                            setStatus("Em chamada");
                                            setHint("");
                                            stopLocalRingback();
                                        }

                                        if (ev === "incomingcall") {
                                            setStatus("Chamada recebida");
                                            const incomingJsep =
                                                jsep?.type && jsep?.sdp
                                                    ? jsep
                                                    : msg.jsep?.type && msg.jsep?.sdp
                                                        ? msg.jsep
                                                        : null;

                                            window.dispatchEvent(
                                                new CustomEvent("incoming-call", {
                                                    detail: { jsep: incomingJsep }
                                                })
                                            );
                                            setIncomingCall(true);

                                            startLocalRingback();

                                        }

                                        if (ev === "hangup") {
                                            setStatus("Chamada finalizada");
                                            setHint("");
                                            setIncomingCall(false);
                                            incomingJsepRef.current = null;
                                            stopLocalRingback();
                                        }

                                        if (jsep && ev !== "incomingcall") {
                                            sessionRef.current?.handleRemoteJsep({ jsep });
                                        }
                                    }
                                });
                            }
                        });

                    }
                });
            })
            .catch(() => {
                setStatus("Permissão de microfone negada");
            });
    };


    useEffect(() => {

        if (!sipReady) return;
        if (!user?.usernameSIP || !user?.secretSIP) return;

        register(user);

    }, [sipReady, user]);

    const hasConnectedRef = useRef(false);

    useEffect(() => {
        if (hasConnectedRef.current) {
            console.log("Já inicializado, ignorando");
            return;
        }

        hasConnectedRef.current = true;

        console.log("Inicializando conexão...");
        connect();

        return () => {
            if (localMicStreamRef.current) {
                localMicStreamRef.current.getTracks().forEach((t) => t.stop());
                localMicStreamRef.current = null;
            }
        };
    }, []);

    const call = () => {
        if (!sessionRef.current) {
            setStatus("Conecte antes");
            return;
        }

        setStatus("Chamando...");

        sessionRef.current.createOffer({
            media: {
                audio: true,
                video: false
            },

            success: (jsep) => {

                sessionRef.current.send({
                    message: {
                        request: "call",
                        uri: "sip:" + number + "@sip.notificame.com.br"
                    },
                    jsep
                });
            },

            error: (err) => {
                console.error("ERRO OFFER", err);
            }
        });
    };

    const hangup = () => {

        waitingForCalleeRef.current = false;


        stopLocalRingback();


        if (sessionRef.current) {
            sessionRef.current.send({
                message: { request: "hangup" }
            });
        }


        setStatus("Desligado");
        setHint("");
        setIncomingCall(false);


        incomingJsepRef.current = null;


        if (localMicStreamRef.current) {
            localMicStreamRef.current.getTracks().forEach((t) => t.stop());
            localMicStreamRef.current = null;
        }

        if (remoteStreamRef.current) {
            remoteStreamRef.current.getTracks().forEach((t) => t.stop());
            remoteStreamRef.current = null;
        }

        if (audioRef.current) {
            audioRef.current.srcObject = null;
        }
    };
    const answer = () => {
        if (!sessionRef.current) {
            setStatus("Conecte (⚡) antes de atender.");
            return;
        }

        if (!incomingJsep?.type || !incomingJsep?.sdp) {
            setStatus("SDP da chamada ausente.");
            return;
        }

        setStatus("Atendendo…");

        const answerOpts = {
            jsep: incomingJsep,

            success: (jsep) => {
                sessionRef.current.send({
                    message: { request: "accept" },
                    jsep
                });

                setStatus("Em chamada");
                setIncomingCall(false);
                setIncomingJsep(null);

                if (audioRef.current) {
                    audioRef.current.play().catch(() => { });
                }
            },

            error: (err) => {
                setStatus("Falha ao atender: " + (err?.message || err));
            }
        };

        const micTrack =
            localMicStreamRef.current?.getAudioTracks()?.[0];

        if (micTrack) {
            answerOpts.tracks = [
                { type: "audio", capture: micTrack, recv: true }
            ];
        } else {
            answerOpts.media = { audio: true };
        }

        sessionRef.current.createAnswer(answerOpts);
    };



    const handleMouseDown = (e) => {
        setDragging(true);
        offsetRef.current = {
            x: e.clientX - position.x,
            y: e.clientY - position.y,
        };
    };

    const handleMouseMove = (e) => {
        if (!dragging) return;

        setPosition({
            x: e.clientX - offsetRef.current.x,
            y: e.clientY - offsetRef.current.y,
        });
    };

    const handleMouseUp = () => {
        setDragging(false);
    };

    return (
        <div
            className="fixed inset-0 z-50 pointer-events-none"
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
        >
            <audio ref={audioRef} autoPlay playsInline />

            <div
                ref={modalRef}
                onMouseDown={handleMouseDown}
                style={{
                    display: isOpen ? "block" : "none",
                    position: "absolute",
                    left: position.x,
                    top: position.y,
                    cursor: dragging ? "grabbing" : "grab",
                }}
                className="pointer-events-auto absolute
                           w-[360px] h-[720px] bg-black rounded-[40px] shadow-2xl p-2"
            >
                <div className="w-full h-full bg-gradient-to-b from-slate-900 to-black rounded-[32px] overflow-hidden relative">

                    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[140px] h-[28px] bg-black rounded-b-2xl z-10"></div>

                    <div className="flex flex-col h-full px-5 pt-10 pb-6 text-white">

                        <div
                            className="flex justify-between items-center mb-4 cursor-grab"
                        >
                            <span className="text-sm text-gray-400">{status}</span>

                            <button
                                onClick={onClose}
                                className="text-gray-400 hover:text-white text-lg"
                            >
                                ✕
                            </button>
                        </div>

                        <div className="text-center text-3xl font-light tracking-wider mb-6">
                            <input type="text"
                                value={number}
                                onChange={(e) => setNumber(e.target.value)}
                                placeholder="Digite o número"
                                className="w-full text-center bg-transparent outline-none placeholder-gray-500"
                            />

                        </div>

                        <div className="grid grid-cols-3 gap-4 flex-1">
                            {["1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "0", "#"].map((n) => (
                                <button
                                    key={n}
                                    onClick={() => add(n)}
                                    className="bg-white/10 backdrop-blur-md hover:bg-white/20 
                                    h-20 w-20 rounded-full flex items-center justify-center 
                                    text-2xl font-semibold transition"
                                >
                                    {n}
                                </button>
                            ))}
                        </div>

                        <button
                            onClick={clearNumber}
                            className="mt-4 text-red-400 text-sm"
                        >
                            Limpar
                        </button>

                        <div className="flex justify-center gap-6 mt-6">
                            {incomingCall ? (

                                <button
                                    onClick={answer}
                                    className="bg-green-500 w-16 h-16 rounded-full"
                                >
                                    📞
                                </button>

                            ) : <button
                                onClick={call}
                                className="bg-green-500 w-16 h-16 rounded-full"
                            >
                                📞
                            </button>
                            }


                            <button
                                onClick={hangup}
                                className="bg-red-500 w-16 h-16 rounded-full"
                            >
                                📴
                            </button>
                        </div>



                    </div>
                </div>
            </div>
        </div>
    );
}